<ng-container *ngIf="vm$ | async as vm">
	<form
		class="flex flex-col h-full"
		#hstForm="ngForm"
		(ngSubmit)="saveAddress(hstForm)"
	>
		<div class="flex flex-grow overflow-y-auto">
			<div class="basis-1/2 flex flex-col w-full p-6">
				<div class="flex flex-col w-full gap-3">
					<ui-checkbox
						label="Set location as primary office"
						[(ngModel)]="vm.businessAddress.primary"
						name="location"
						[disabled]="vm.primaryOrig"
						matTooltip="Primary office is mandatory. Select a new primary office to change defaults."
						[matTooltipDisabled]="!vm.primaryOrig"
					/>
					<app-input
						label="Office Name (Official: used in documents)"
						name="officeName"
						[required]="true"
						[submitted]="vm.submitted"
						[(ngModel)]="vm.businessAddress.officeName"
						[testHook]="testHooks.OfficeName"
					></app-input>
					<app-input
						label="Office Name (Nickname: used to assign matters)"
						name="officeNickName"
						[submitted]="vm.submitted"
						[(ngModel)]="vm.businessAddress.officeNickName"
						[testHook]="testHooks.OfficeNickName"
					></app-input>
					<app-input
						label="HST Registration number"
						name="hstRegistrationNumber"
						hstRegistrationNumberFormat
						[submitted]="vm.submitted"
						[(ngModel)]="vm.businessAddress.hstRegistrationNumber"
						[testHook]="testHooks.HstRegistrationNumber"
					></app-input>
					<app-input
						label="Fax"
						name="fax"
						[(ngModel)]="vm.businessAddress.faxNumber"
						[testHook]="testHooks.Fax"
					></app-input>
					<app-input
						label="Work phone"
						name="workPhone"
						[(ngModel)]="vm.businessAddress.phoneNumber"
						[testHook]="testHooks.WorkPhone"
					></app-input>
					<app-input
						label="Cell phone"
						name="cellPhone"
						[(ngModel)]="vm.businessAddress.cellPhone"
						[testHook]="testHooks.CellPhone"
					></app-input>
					<app-input
						label="Email"
						name="email"
						[(ngModel)]="vm.businessAddress.email"
						[testHook]="testHooks.Email"
					></app-input>

					<app-address
						name="Address"
						[address]="vm.businessAddress"
						(onAddressUpdate)="onAddressUpdate($event)"
						[enableCountrySelect]="true"
					>
					</app-address>
				</div>
				<div class="flex flex-col mt-6 gap-3">
					<h4>Signing Location</h4>
					<div class="grid grid-cols-2 gap-3">
						<app-select
							label="Location"
							[required]="true"
							[(ngModel)]="vm.businessAddress.signingLocationType"
							name="locationType"
							[submitted]="vm.submitted"
							placeholder="Select location type"
							[testHook]="testHooks.LocationSelect"
						>
							@for (
								locationType of locationTypeDropdownOptions;
								track locationType.id
							) {
								<option [value]="locationType.id" [testHook]="testHooks.Option">
									{{ locationType.label }}
								</option>
							}
						</app-select>
						<app-input
							label="Location Specified"
							name="signingLocation"
							[(ngModel)]="vm.businessAddress.signingLocation"
							[required]="true"
							[testHook]="testHooks.LocationSpecified"
						></app-input>
						<app-select
							label="Region"
							[required]="true"
							[(ngModel)]="vm.businessAddress.signingRegionType"
							name="signingRegionType"
							[submitted]="vm.submitted"
							placeholder="Select region type"
							[testHook]="testHooks.RegionSelect"
						>
							@for (
								regionType of regionTypeDropdownOptions;
								track regionType.id
							) {
								<option [value]="regionType.id" [testHook]="testHooks.Option1">
									{{ regionType.label }}
								</option>
							}
						</app-select>
						<app-input
							label="Region Specified"
							name="signingRegion"
							[(ngModel)]="vm.businessAddress.signingRegion"
							[required]="true"
							[testHook]="testHooks.RegionSpecified"
						></app-input>
					</div>
					@if (hasSigningLocationData) {
						<div class="rounded-md bg-gray-50 p-4 mt-3">
							<div class="font-semibold text-base">
								Signing Location Preview Text
							</div>
							<div class="text-sm text-gray-500 mt-3">
								{{ vm.businessAddress.signingLocationType }} of
								{{ vm.businessAddress.signingLocation }},
								{{ vm.businessAddress.signingRegionType }} of
								{{ vm.businessAddress.signingRegion }}
							</div>
						</div>
					}
				</div>
				<div class="flex flex-col mt-6 gap-3">
					<h4>Commissioner</h4>
					<ui-button-segmented
						label="Default Commissioner On Matter"
						[options]="commissionerRadioGroupItems"
						[(selectedId)]="vm.businessAddress.commissionerSelectionType"
						[fullWidth]="true"
						variant="text-only"
						[testHook]="testHooks.DefaultCommissionerOnMatterButtonSegmented"
					></ui-button-segmented>
					<app-business-user-dropdown
						*ngIf="
							vm.businessAddress.commissionerSelectionType ===
							COMMISSIONER_SELECTION_TYPE.OTHER
						"
						label="Specify Commissioner"
						[userId]="vm.businessAddress.otherCommissionerId"
						(selected)="setCommissionerUser($event)"
					></app-business-user-dropdown>
				</div>
				<div class="flex flex-col mt-6 gap-3">
					<h4>Witness</h4>
					<ui-button-segmented
						label="Default Witness On Matter"
						[options]="witnessRadioGroupItems"
						[(selectedId)]="vm.businessAddress.witnessSelectionType"
						[fullWidth]="true"
						variant="text-only"
						[testHook]="testHooks.DefaultWitnessOnMatterButtonSegmented"
					></ui-button-segmented>
					<app-business-user-dropdown
						*ngIf="
							vm.businessAddress.witnessSelectionType ===
							WITNESS_SELECTION_TYPE.OTHER
						"
						label="Specify Witness"
						[userId]="vm.businessAddress.otherWitnessId"
						(selected)="setWitnessUser($event)"
					></app-business-user-dropdown>
				</div>
			</div>
			<div class="basis-1/2 h-full bg-gray-100 sticky top-0">
				@if (vm.businessAddress.logoFile) {
					<div
						class="flex justify-between items-center py-2 px-4 gap-x-4 bg-gray-200"
					>
						<p class="font-semibold">Office Logo Upload</p>
						<ui-button
							size="small"
							preset="DANGER"
							icon="trash"
							class="self-start"
							(click)="resetLogo()"
							label="Delete logo"
							[testHook]="testHooks.DeleteLogoButton"
						></ui-button>
					</div>
					<div class="h-full flex items-center justify-center">
						<img
							[src]="vm.businessAddress.logoFile.url"
							alt="Office Logo"
							class="w-60 h-60 object-contain aspect-square"
						/>
					</div>
				} @else {
					<div class="m-10 bg-white rounded-xl">
						<div class="pt-6 px-6 space-y-6">
							<p class="font-semibold">Office Logo Upload</p>
							<p class="text-sm">
								For ideal quality upload images that are in square format at a
								minimum resolution of 500x500px.
							</p>
						</div>
						<app-file-upload
							type="dropzone"
							class="w-60 h-60 shrink-0"
							(fileSelected)="fileSelected($event)"
							(success)="onSuccess($event)"
							[docId]="docId_()"
							[fileTypes]="FILE_IMAGE_TYPES"
							[testHook]="testHooks.LogoDropzone"
						>
						</app-file-upload>
					</div>
				}
			</div>
		</div>
		<div class="p-6 border-t border-gray-200">
			<ui-button
				preset="HIGH_EMPHASIS"
				label="Save"
				[disabled]="vm.busy"
				[loading]="vm.busy"
				type="submit"
				[testHook]="testHooks.SaveButton"
			></ui-button>
		</div>
	</form>
</ng-container>
